import controller from './cart.controller';
import templateBase from './templates/cart-base.view.html';
import templateT1 from './templates/cart-t1.view.html';
import templateT10 from './templates/cart-t10.view.html';
import templateT15 from './templates/cart-t15.view.html';
import templateAD from './templates/cart-base.view-adaptative.html';

let CartComponent = {
  template: changeTemplate,
  controller,
  bindings: {
    shCtrl: '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  if (__env.adaptative) {
    return templateAD;
  } else {
    if (response.CART.component == 'template_t1') { return templateT1; }
    else if (response.CART.component == 'template_t10') { return templateT10; }
    else if (response.CART.component == 'template_t15') { return templateT15; }
    else {
      return templateBase;
    }
  }
}

export default CartComponent;


// WEBPACK FOOTER //
// ./www/components/cart/cart.component.js